import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTButtonModule } from './lt-button/lt-button.module';
import { LTCardModule } from './lt-card/lt-card.module';
import { LTGridUIModule } from './lt-grid-ui/lt-grid-ui.module';
import { LTInfoModule } from './lt-info/lt-info.module';
import { LTMonacoModule } from './lt-monaco/lt-monaco.module';
@NgModule({
  imports: [
    CommonModule,
    LTButtonModule,
    LTCardModule,
    LTGridUIModule,
    LTInfoModule,
    LTMonacoModule,
  ],
  exports: [
    LTButtonModule,
    LTCardModule,
    LTGridUIModule,
    LTInfoModule,
    LTMonacoModule,
  ],
})
export class LTSharedUIModule { }